import React, { ReactNode } from 'react';
import BaseModal from 'react-modal';
import cn from 'classnames';
import { ButtonVariant } from '@app/types';

BaseModal.setAppElement('#modals');

function Header({ className = '', children, ...props }) {
  className = `modal-header ${className || ''}`.trim();

  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}

export type ModalProps = ReactModal.Props & {
  containerClassName?: string;
  centered?: boolean;
  forceDarkMode?: boolean;
  className?: string;
  overlayClassName?: string;
};

interface ModalButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  variant?: ButtonVariant;
}

export function ModalButton({ children, className, variant = null, ...props }: ModalButtonProps) {
  className = cn('btn', className, variant ? `btn-${variant}` : null);

  return (
    <button className={className} type="button" onKeyDown={(e) => e.stopPropagation()} {...props}>
      {children}
    </button>
  );
}

const ModalContainer = ({ children, className, onRequestClose }: { children: ReactNode; className?: string; onRequestClose?: (e) => void; }) => {
  return (
    <div
      className={cn('modal-container', className)}
      onKeyDown={(e) => {
        e.stopPropagation()

        if (e.key === 'Escape') {
          onRequestClose?.(e)
        }
      }}
    >
      {children}
    </div>
  )
}

export default function Modal({
  children,
  className = null,
  containerClassName = null,
  overlayClassName = null,
  centered = false,
  forceDarkMode = false,
  ...props
}: ModalProps) {
  return (
    <BaseModal
      closeTimeoutMS={0}
      className={cn('modal-wrapper', className)}
      overlayClassName={cn(
        'modal-overlay',
        centered && 'modal-overlay-centered',
        forceDarkMode && 'forceDarkMode',
        overlayClassName,
      )}
      {...props}
    >
      {/* <div className={cn('modal-container', containerClassName)}>{children}</div> */}
      <ModalContainer className={containerClassName} onRequestClose={props.onRequestClose}>{children}</ModalContainer>
    </BaseModal>
  );
}

Modal.Header = Header;
